import axios from 'axios';
import * as authn from '@byuweb/browser-oauth';
// @ts-ignore
import { get } from 'lodash';
let refreshDialogVisible = false;
const errorMessages = [];
export default (context) => {
    context.$axios.onResponseError((error) => {
        if (axios.isCancel(error)) {
            // Explicit cancellation, so do not show "error" message
            return;
        }
        if (error.config && error.response?.status === 401) {
            // @ts-ignore Internal var added to config, so we can tell if this is a second automated attempt
            if (!error.config.insideRetry) {
                return retryWithRefreshedToken(error);
            }
            // Auto-refresh should happen in iframe background in ./implicit-grant.js
            // If that fails, then we can't auto-refresh, so...
            if (!refreshDialogVisible) {
                const failDuringPost = error.config.method !== 'get';
                refreshDialogVisible = true;
                context.$dialog
                    .authRefreshRequired({
                    failDuringPost,
                    persistent: true,
                    waitForResult: true,
                })
                    // @ts-ignore: Third-party Typescript definition file is not correct: "show" can return a Promise
                    .then(() => (refreshDialogVisible = false));
            }
            return false;
        }
        if (error?.config?.noAutoError || process.env.NUXT_ENV_NO_AXIOS_AUTO_ERROR) {
            // Caller has declared that it will handle unknown errors instead of using auto-popup
            return;
        }
        context.$axios.defaultErrorPopup(error);
    });
    context.$axios.defaultErrorPopup = (error) => {
        const text = get(error, 'response.data.errorMessage') ||
            get(error, 'response.data.readable_message') ||
            get(error, 'response.data.metadata.validation_response.message') ||
            get(error, 'response.data.ResolveIdentityService.errors.0.message') ||
            get(error, 'response.data.message') ||
            get(error, 'response.data.error.message') ||
            get(error, 'response.headers.x-error-message') ||
            error.message ||
            'Unknown Error';
        // Only pop up one copy of each error message at a time
        if (!errorMessages.includes(text)) {
            errorMessages.push(text);
            context.$dialog.error({ title: 'Error', icon: false, text }).then(() => {
                const index = errorMessages.indexOf(text);
                if (index !== -1) {
                    errorMessages.splice(index, 1);
                }
            });
        }
    };
    let refreshPromise = null;
    function retryWithRefreshedToken(error) {
        if (!refreshPromise) {
            refreshPromise = authn.refresh('iframe').finally(() => (refreshPromise = null));
        }
        return refreshPromise.then((tokenInfo) => {
            const config = Object.assign({ insideRetry: true }, error.config);
            if (tokenInfo?.state === authn.STATE_AUTHENTICATED && tokenInfo.token?.authorizationHeader) {
                config.headers.Authorization = tokenInfo.token.authorizationHeader;
            }
            return context.$axios.request(config);
        });
    }
};
//# sourceMappingURL=axios.js.map